import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountDashboardController from "../Controllers/AccountDashboardController";
import Dropdown from "../../Components/Dropdown";
import LoadingSkeleton from "../../Components/LoadingSkeleton";
import AddExpenseModal from '../Components/AddExpenseModal';

const AccountDashboardScreen = ({ yearList, selectedYear, setSelectedYear, yearError, yearLoading, dashboardData, dashboardLoading, dashboardError, setSelectedTab, onRefresh }) => {
    const {
        openModal,
        closeModal,
        showModal,
        expenseInfoRef
    } = AccountDashboardController();

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    // console.log("dashboardData", dashboardData)

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const formatIndianCurrency = (value) => {
        if (typeof value !== 'number' || isNaN(value)) return "--";
        return new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    };

    const navigate = useNavigate();

    const handleCardClick = (title, key, label, action_type) => {
        navigate("/status-list", {
            state: {
                title: title,
                report_key: key,
                heading: label,
                action_type: action_type,
                selectedYear: selectedYear,
            }
        });
    };

    const renderCard = (label, value) => {
        const isNetAmount = label === 'Net Amount Payable';
        const isValueNumber = typeof value === 'number' && !isNaN(value);
        const isValueZero = isValueNumber && value === 0;
        const isValueMissing = value === '--';

        const showUnderline = !isValueMissing && !isNetAmount;
        const isClickable = !isValueMissing && !isValueZero && !isNetAmount;
        let title, key, action_type;
        if (label === 'Expense Pending for Approval') {
            title = 'Expense wise Reports';
            key = 'pending_expenses';
            label = 'Pending Expenses';
            action_type = 'pending_expenses';
        } else if (label === 'Disbursement Pending for Approval') {
            title = 'Disbursement wise Reports';
            key = '';
            label = 'Pending Disbursement';
            action_type = 'pending_disbursement';
        } else {
            title = '';
            key = '';
            label = 'Net Amount Payable';
            action_type = '';
        }

        let cursorStyle = 'pointer';
        if (isNetAmount) {
            cursorStyle = 'default';
        } else if (!isClickable) {
            cursorStyle = 'not-allowed';
        }

        return (
            <div className="task-label-container" style={{ justifyContent: 'space-between' }}>
                <div className="task-label" style={{ color: '#505470' }}>{label}</div>
                <span
                    style={{
                        ...styles.itemValue,
                        color: isNetAmount ? '#000000' : styles.itemValue?.color || '#007bff',
                        textDecoration: showUnderline ? 'underline' : 'none',
                        cursor: cursorStyle,
                    }}
                    onClick={isClickable && !dashboardLoading ? () => handleCardClick(title, key, label, action_type) : undefined}
                >
                    {dashboardLoading ? (
                        <LoadingSkeleton width="50px" height="10px" />
                    ) : (
                        isValueNumber
                            ? value < 10 ? `0${value}` : value
                            : value ?? '--'
                    )}
                </span>
            </div >
        );
    };

    return (
        <div>
            <div className="title-container" style={{ paddingBottom: 10, gap: '25px' }}>
                <div className="title-container" style={{ paddingBottom: 10, gap: '25px', justifyContent: 'flex-start' }}>
                    <h2 className='tab-componrnt-title'>Account Dashboard</h2>
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Financial Year"] = el)}
                        isOpen={openDropdown === "Financial Year"}
                        toggleDropdown={() => toggleDropdown("Financial Year")}
                        options={yearList}
                        value={selectedYear}
                        onChange={setSelectedYear}
                        dashboardLoading={yearLoading}
                        errorMessage={yearError}
                        style={{ backgroundColor: '#fff', borderRadius: '50px', width: '120px', height: '12px' }}
                        disabledSelect={true}
                    />
                </div>
                <div>
                    <button className="tasksScreen-apply-button" style={{ paddingTop: '10px', paddingBottom: '10px' }} onClick={openModal}>Add Expense</button>
                </div>
            </div>

            {showModal && <AddExpenseModal isOpen={showModal} onClose={closeModal} editData={expenseInfoRef.current} onValueChange={onRefresh} />}

            <div>
                <div className="overview-content">
                    <div style={{ background: '#F7F8FA', padding: '20px', borderRadius: '4px', flex: 'auto' }}>
                        {renderCard("Expense Pending for Approval", dashboardData?.expenses_pending)}
                    </div>
                    <div style={{ background: '#F7F8FA', padding: '20px', borderRadius: '4px', flex: 'auto' }}>
                        {renderCard("Disbursement Pending for Approval", dashboardData?.disbursements_pending)}
                    </div>
                    <div style={{ background: '#F7F8FA', padding: '20px', borderRadius: '4px', flex: 'auto' }}>
                        {renderCard("Net Amount Payable", dashboardData?.net_payable ? formatIndianCurrency(dashboardData?.net_payable) : "--")}
                    </div>
                </div >
                {
                    dashboardError && !dashboardLoading && (
                        <p style={{ color: 'red', fontSize: '12px' }}>{dashboardError}</p>
                    )
                }
            </div >

        </div >
    );
};

const styles = {
    itemValue: {
        fontWeight: "700",
        color: "#5A55D2",
        fontSize: '16px',
    }
};

export default AccountDashboardScreen;